import { useSearchFeedsQuery } from '../graphql'
import { ACTIVE_FEEDS_QUERY_VARIABLES } from '../utils'
import { type ActiveIntegration } from '../types'

export const useActiveIntegrationsFeeds = () => {
	const { data, isLoading, isError } = useSearchFeedsQuery( ACTIVE_FEEDS_QUERY_VARIABLES, {
		refetchInterval: 120000, // 2 minutes
	} )
	const integrations: ActiveIntegration[] = data?.searchFeeds?.feeds ?? []

	return { integrations, isLoading, isError }
}
